import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import HFMModal from '../hfm-modal';
import SongUpload from '../song-upload';

import FormList from './song-form-list';

@inject('songsStore', 'formStore', 'albumsStore')
@observer
class NewSongModal extends Component {
	render () {
		const { songsStore } = this.props;

		return (
			<div>
				<HFMModal
					isOpen={ songsStore.songModalOpen }
					contentLabel="New Song"
					styles={{
						base: 'modal new-song'
					}}
				>
					<div className='modal-content'>
						<div className="grid-x">
							<div className="cell">
								{ this.renderMainContent() }
							</div>
						</div>

						<div className="modal-button-group padding-left-0">
							{ this.renderSaveBtn() }
							<button
								className="button clear secondary padding-left-0"
								onClick={ this.handleCloseModal }
							>
								Close Modal
							</button>
						</div>
					</div>
				</HFMModal>

				<button className="add-button button" onClick={ this.handleOpenModal }>
					<span className="icon fi-plus"></span> Submit Music
				</button>
			</div>
		);
	}

	renderSaveBtn () {
		const { songsStore } = this.props;
		const newSongs = songsStore.newSongs;

		if (_.isEmpty(newSongs)) {

			return null;
		}

		return <button className="button clear" onClick={ this.onClick }>Save</button>;
	}

	renderMainContent () {
		const { songsStore, formStore, artist } = this.props;
		const newSongs = songsStore.newSongs;

		if (_.isEmpty(newSongs)) {

			return (
				<SongUpload
					fullWidth
					artist={ artist }
					formStore={ formStore }
					songsStore={ songsStore }
				/>
			);
		}

		const { albumsStore } = this.props;

		return (
			<FormList songList={ newSongs } />
		);
	}

	@autobind
	onClick () {
		this.props.songsStore.saveSong();
	}

	@autobind
	handleOpenModal () {
		this.props.songsStore.songModalOpen = true;
	}

	@autobind
	handleCloseModal () {
		this.props.songsStore.songModalOpen = false;
	}
}

export default NewSongModal;
